const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const MS_DAY=864e5;

function freshness(row,maxAgeDays,nowMs){
 const verified=String(row?.verification_status||'').toUpperCase()==='VERIFIED';
 if(!verified)return{status:'MISSING',ageDays:null,usable:false};
 const t=+new Date(row?.as_of||0);
 if(!Number.isFinite(t)||t<=0)return{status:'DATE_MISSING',ageDays:null,usable:false};
 const ageDays=(nowMs-t)/MS_DAY;
 if(ageDays<0)return{status:'FUTURE_REJECTED',ageDays:null,usable:false};
 if(ageDays>maxAgeDays)return{status:'STALE',ageDays,usable:false};
 return{status:'LIVE',ageDays,usable:true};
}

export function deriveSheepEvidence(bundle={},now=new Date()){
 const nowMs=+new Date(now);
 if(!Number.isFinite(nowMs))return{status:'MISSING',state:'MISSING',note:'Crowding evidence clock could not be evaluated.'};

 const short=bundle?.shortInterest||{};
 const ownership=bundle?.grasshopper||{};
 const shortHealth=freshness(short,45,nowMs);
 const ownershipHealth=freshness(ownership,120,nowMs);

 const shortFloat=shortHealth.usable?N(short?.short_float_pct):null;
 const daysToCover=shortHealth.usable?N(short?.days_to_cover):null;
 const shortShares=shortHealth.usable?N(short?.short_interest_shares):null;
 const floatShares=shortHealth.usable?N(short?.float_shares):null;

 const top10=ownershipHealth.usable?N(ownership?.top10_holder_pct):null;
 const institutionalLocked=ownershipHealth.usable?N(ownership?.institutional_locked_pct):null;
 const insiderLocked=ownershipHealth.usable?N(ownership?.insider_locked_pct):null;

 let shortState='MISSING';
 if(shortFloat!=null){
  shortState=shortFloat>=20?'HIGH_SHORT_CROWDING':shortFloat>=10?'ELEVATED_SHORT_CROWDING':'LOW_SHORT_CROWDING_EVIDENCE';
 }
 let ownershipState='MISSING';
 if(top10!=null){
  ownershipState=top10>=70?'HIGH_HOLDER_CONCENTRATION':top10>=50?'ELEVATED_HOLDER_CONCENTRATION':'LOW_HOLDER_CONCENTRATION_EVIDENCE';
 }

 const shortElevated=['HIGH_SHORT_CROWDING','ELEVATED_SHORT_CROWDING'].includes(shortState);
 const holderElevated=['HIGH_HOLDER_CONCENTRATION','ELEVATED_HOLDER_CONCENTRATION'].includes(ownershipState);

 let state='MISSING';
 if(shortState!=='MISSING'||ownershipState!=='MISSING'){
  if(shortElevated&&holderElevated)state='MULTI_CROWDING';
  else if(shortState==='HIGH_SHORT_CROWDING')state='SHORT_CROWDED';
  else if(ownershipState==='HIGH_HOLDER_CONCENTRATION')state='HOLDER_CONCENTRATED';
  else if(shortElevated||holderElevated)state='ELEVATED_CROWDING';
  else if(shortState!=='MISSING'&&ownershipState!=='MISSING')state='LOW_CURRENT_CROWDING_EVIDENCE';
  else state='PARTIAL_CROWDING_EVIDENCE';
 }

 return{
  status:state==='MISSING'?'MISSING':'EVIDENCE',
  state,
  shortState,
  ownershipState,
  shortFloatPct:shortFloat,
  daysToCover,
  shortInterestShares:shortShares,
  floatShares,
  top10HolderPct:top10,
  institutionalLockedPct:institutionalLocked,
  insiderLockedPct:insiderLocked,
  shortFreshness:shortHealth.status,
  ownershipFreshness:ownershipHealth.status,
  shortAgeDays:shortHealth.ageDays,
  ownershipAgeDays:ownershipHealth.ageDays,
  thresholds:{shortElevatedPct:10,shortHighPct:20,top10ElevatedPct:50,top10HighPct:70,shortMaxAgeDays:45,ownershipMaxAgeDays:120},
  note:'Sheep uses only verified short-interest and holder-concentration evidence. Days-to-cover, institutional locking and insider locking are context only; they cannot create a crowding state by themselves. Missing, stale or future evidence stays out of the signal.'
 };
}
